import configurations from "./environments"

const environment = import.meta.env?.VITE_REACT_APP_ENV || process.env.REACT_ENV || "local"
console.log("environment", { environment, en: import.meta.env, pen: process.env })
const config = configurations[environment as keyof typeof configurations]
if (!config) throw `Configuration not found for environment: ${environment}`

// DEV ONLY: point the main API at a locally running quark (full local stack)
// without touching the environment maps, e.g.
//   VITE_QUARK_URL=http://localhost:4900/graphql/
const quarkUrlOverride = import.meta.env?.VITE_QUARK_URL

export default {
  ...config,
  quark: quarkUrlOverride ? { ...config.quark, url: quarkUrlOverride } : config.quark,
  name: environment
}
